export default {
  root: {
    fontSize: 12,
  },
}
